(() => {
  if (window.__cartRewardProgressLoaded) return;
  window.__cartRewardProgressLoaded = true;

  const STORAGE_KEY = 'cart_reward_level';
  const TRIGGER_CLASS = 'cart-reward--trigger';

  const getLevel = (el) => {
    const level = parseInt(el.dataset.rewardLevel || '0', 10);
    return Number.isNaN(level) ? 0 : level;
  };

  const triggerPulse = (el) => {
    el.classList.remove(TRIGGER_CLASS);
    void el.offsetWidth;
    el.classList.add(TRIGGER_CLASS);
  };

  const launchConfetti = (el) => {
    const rect = el.getBoundingClientRect();
    if (!rect.width || !rect.height) return;

    const existing = el.querySelector('.cart-reward__confetti');
    if (existing) existing.remove();

    const canvas = document.createElement('canvas');
    canvas.className = 'cart-reward__confetti';
    canvas.width = Math.round(rect.width);
    canvas.height = Math.round(rect.height);
    canvas.style.width = `${rect.width}px`;
    canvas.style.height = `${rect.height}px`;
    el.style.position = 'relative';
    el.appendChild(canvas);

    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    const colors = [
      '#111827',
      '#3b82f6',
      '#10b981',
      '#f59e0b',
      '#ef4444',
      '#8b5cf6',
    ];

    const particles = Array.from({ length: 70 }, () => {
      const angle = Math.random() * Math.PI * 2;
      const speed = 2 + Math.random() * 4;
      return {
        x: rect.width / 2,
        y: rect.height / 2,
        vx: Math.cos(angle) * speed,
        vy: Math.sin(angle) * speed - 2,
        size: 3 + Math.random() * 3,
        color: colors[Math.floor(Math.random() * colors.length)],
        rotation: Math.random() * Math.PI,
      };
    });

    const start = performance.now();
    const duration = 1200;

    const tick = (now) => {
      const elapsed = now - start;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      particles.forEach((p) => {
        p.x += p.vx;
        p.y += p.vy;
        p.vy += 0.12;
        p.rotation += 0.2;
        ctx.save();
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rotation);
        ctx.fillStyle = p.color;
        ctx.fillRect(-p.size / 2, -p.size / 2, p.size, p.size);
        ctx.restore();
      });

      if (elapsed < duration) {
        requestAnimationFrame(tick);
      } else {
        canvas.remove();
      }
    };

    requestAnimationFrame(tick);
  };

  const handleReward = (el) => {
    const effect = el.dataset.rewardEffect || 'none';
    const context = el.dataset.rewardContext || 'default';
    const level = getLevel(el);
    const storageKey = `${STORAGE_KEY}:${context}`;

    let previous = sessionStorage.getItem(storageKey);
    if (previous === null) {
      sessionStorage.setItem(storageKey, String(level));
      return;
    }

    const previousLevel = parseInt(previous, 10) || 0;
    if (level > previousLevel) {
      if (effect === 'pulse') {
        triggerPulse(el);
      } else if (effect === 'confetti') {
        triggerPulse(el);
        launchConfetti(el);
      }
    }

    sessionStorage.setItem(storageKey, String(level));
  };

  const run = () => {
    document.querySelectorAll('[data-cart-reward]').forEach(handleReward);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS?.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      setTimeout(run, 0);
    });
  }
})();
